import { createContext, useContext } from "react";

import { AbortControllerInfo, ProgressModalState, UploadFile } from "../types";

interface UploadContextInterface {
  uploadProgressState: ProgressModalState;
  setUploadProgressState: (
    value:
      | ProgressModalState
      | ((prev: ProgressModalState) => ProgressModalState),
  ) => void;
  uploadFiles: UploadFile[];
  setUploadFiles: (
    value: UploadFile[] | ((prev: UploadFile[]) => UploadFile[]),
  ) => void;
  abortControllers: AbortControllerInfo[];
  setAbortControllers: (
    value:
      | AbortControllerInfo[]
      | ((prev: AbortControllerInfo[]) => AbortControllerInfo[]),
  ) => void;
  uploadInProgress: boolean;
  setUploadInProgress: (value: boolean | ((prev: boolean) => boolean)) => void;
}

const emptyProgressModalState: ProgressModalState = {
  shouldOpen: false,
  title: "",
};

const defaultUploadState = {
  uploadProgressState: emptyProgressModalState,
  setUploadProgressState: (): ProgressModalState => emptyProgressModalState,
  uploadFiles: [],
  setUploadFiles: (): UploadFile[] => [],
  abortControllers: [],
  setAbortControllers: (): AbortControllerInfo[] => [],
  uploadInProgress: false,
  setUploadInProgress: (): boolean => false,
};

const UploadContext = createContext<UploadContextInterface>(defaultUploadState);

export const useUploadContext = (): UploadContextInterface =>
  useContext(UploadContext);

export default UploadContext;
